import { Icon, type IconTone } from "@/components/ui"
import { CreditCardIcon, MoneyIcon, PixIcon, type IconGlyph } from "@/icons"
import { PaymentMethod as PaymentMethodType } from "@/types"

function glyphFor(kind: PaymentMethodType): IconGlyph {
  switch (kind) {
    case "CASH":
      return MoneyIcon
    case "PIX":
    case "PIX_ONLINE":
      return PixIcon
    default:
      return CreditCardIcon
  }
}

/**
 * Icon for a payment method. PIX and PIX_ONLINE deliberately share one.
 *
 * Kept out of `PaymentMethod.tsx` so that module exports a component and
 * nothing else — mixing the two breaks Vite's fast refresh for the whole file.
 */
export function getPaymentIcon(kind: PaymentMethodType, className?: string, tone: IconTone = "primary") {
  return <Icon as={glyphFor(kind)} size="xl" tone={tone} className={className} />
}
